<template>
  <div class="pos-access-denied">
    <div class="pos-access-denied__content">
      <div class="pos-access-denied__icon-wrapper">
        <i class="fa-solid fa-lock pos-access-denied__icon" />
      </div>

      <h3 class="pos-access-denied__title">
        {{ $t('Access Denied') }}
      </h3>

      <p class="pos-access-denied__text">
        {{ $t('You do not have permission to access this page.') }}
      </p>
      <p class="pos-access-denied__hint">
        <i class="fa-solid fa-circle-info me-1" />
        {{ $t('If you feel this is a mistake, contact your admin.') }}
      </p>

      <button
        v-if="showButton"
        class="btn btn-lg pos-access-denied__btn mt-3"
        @click="clickGoBack()"
      >
        <i class="fa-solid fa-arrow-left me-2" />
        {{ showButtonText ? $t(showButtonText) : $t('Go Back') }}
      </button>
    </div>
  </div>
</template>

<script lang="js">
export default {
  props: {
    showButton: {
      type: [String, Boolean],
      default: false,
    },
    showButtonText: {
      type: [String, Boolean],
      default: false,
    },
    isCloseModal: {
      type: [String, Boolean],
      default: false,
    },
  },
  methods: {
    clickGoBack() {
      if (this.isCloseModal) {
        this.$parent.closeModal?.();
      } else {
        this.$parent.closeModalForm?.();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pos-access-denied {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 2rem 1rem;

  &__content {
    text-align: center;
    max-width: 480px;
    width: 100%;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 20px;
    padding: 2.5rem 2rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
  }

  &__icon-wrapper {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: rgba(233, 108, 21, 0.1);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.25rem;
  }

  &__icon {
    font-size: 2.75rem;
    color: #E96C15;
  }

  &__title {
    color: #212529;
    font-weight: 800;
    letter-spacing: 0.3px;
    margin-bottom: 0.75rem;
  }

  &__text {
    color: #495057;
    font-size: 1rem;
    margin-bottom: 0.35rem;
  }

  &__hint {
    color: #6c757d;
    font-size: 0.9rem;
    margin-bottom: 0;
  }

  &__btn {
    background-color: #E96C15;
    border-color: #E96C15;
    color: #fff;
    font-weight: 600;
    padding: 0.65rem 1.75rem;
    border-radius: 999px;
    transition: all 0.2s ease;

    &:hover,
    &:focus {
      background-color: #d46010;
      border-color: #d46010;
      color: #fff;
      box-shadow: 0 4px 12px rgba(233, 108, 21, 0.35);
    }
  }
}
</style>
